import { DeliveryChannel } from '@pushly/aqe/lib/enums/delivery-channels'

export function mapDataKeyFromObjectList(key: string, objList: any[], channel: DeliveryChannel) {
    return objList.filter((val) => val.channel === channel).map((filtered) => filtered[key] || 0)
}
